import { useEffect, useState } from "react";
import { useTransactions } from "../../elements/frontend/src/hooks";
import { InvestorProps } from "../../elements/frontend/src/Store/interfaces";
import { setCurrentUser } from "../../elements/frontend/src/Store/currentUser/currentUserSlice";
import { useDispatch } from "react-redux";
export function useInvitedInvestors({ transactionId, transaction, company }: any) {
  const { updateTransaction } = useTransactions();
  const [invitations, setInvtations] = useState<InvestorProps[]>([]);
  const dispatch = useDispatch();

  const saveInvestors = async (invitations: InvestorProps[]) => {
    const body = {
      investors: invitations.map((inv) => ({
        customer_id: inv.id,
      })),

      metadata: [
        {
          scope: "investment",
          data: {
            investors: invitations,
          },
        },
      ],
    };

    await updateTransaction(transactionId, body);
  };

  useEffect(() => {
    const savedInvitations = transaction?.metadata.find(
      (metadata: any) => metadata.scope === "investment"
    )?.data?.investors;
    if (savedInvitations) {
      setInvtations(savedInvitations);
    }
  }, [transaction]);

  const isInvited = (id: string) => {
    if (Array.isArray(invitations)) {
      const exists = invitations.filter((inv: InvestorProps) => inv.id === id);
      return exists.length > 0;
    }
  };

  const inviteInvestor = async (investor: InvestorProps) => {
    if (isInvited(investor.id)) return;
    dispatch(setCurrentUser({ loading: true }));
    const updateInvestor = [...invitations, investor];
    setInvtations(updateInvestor);
    await saveInvestors(updateInvestor);
    const investors = updateInvestor.map((investor) => ({
      customer_id: investor.id,
      metadata: [
        {
          scope: "state",
          data: {
            invited: true,
          },
        },
      ],
    }));

    const body = {
      investors: investors,
    };
    await updateTransaction(transactionId, body);
    dispatch(setCurrentUser({ loading: false }));
  };

  const isWhiteListed = (id: string) => {
    if (company) {
      const advisorMeta = company.metadata.find((item: any) => item.scope === "company").data;
      const whitelist = advisorMeta.investor_whitelist || [];
      return whitelist.includes(id);
    }
  };

  const unInviteInveestor = (investor: InvestorProps) => {
    if (company) {
      if (isWhiteListed(investor.id)) {
        const confirm = window.confirm(`Möchten sie ${investor.name} wirklich ausladen?`);
        if (confirm === true) {
          setInvtations((prev) => {
            return prev.filter((inv) => inv.id !== investor.id);
          });
        }
      }
    }
  };

  return {
    inviteInvestor,
    invitations,
    loadingInvitations: false,
    isInvited,
    isWhiteListed,
    unInviteInveestor,
  };
}
